import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { catchError, map, of, timeout } from 'rxjs';

import { environment } from '../../../environments/environment';

export type BackendStatus = 'checking' | 'reachable' | 'unreachable';

@Injectable({ providedIn: 'root' })
export class BackendStatusService {
  readonly status = signal<BackendStatus>('checking');

  constructor(private readonly httpClient: HttpClient) {}

  checkBackendReachability(): void {
    this.status.set('checking');

    this.httpClient
      .get(`${environment.externalApiBaseUrl}/backend-status`)
      .pipe(
        timeout(5000),
        map(() => 'reachable' as BackendStatus),
        catchError((_error: HttpErrorResponse) => of('unreachable' as BackendStatus))
      )
      .subscribe((nextStatus) => this.status.set(nextStatus));
  }

  markReachable(): void {
    if (this.status() !== 'reachable') {
      this.status.set('reachable');
    }
  }

  markUnreachableIfBackendNotReachable(error: HttpErrorResponse): void {
    if (error.status === 0) {
      this.status.set('unreachable');
    }
  }
}
